<script>
	import { onMount } from "svelte";

	import { pageNumber, model } from "../../stores";
	import { projectSettings } from "../../config";
	import { registerFormStart } from "../../tealium";

	import PageSection from "../../components/PageSection.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	export let title = null;
	export let pageIndex = null;
	export let pageTitle = null;
	export let nextPage = null;
	export let lastVisitedPage = null;

	$pageNumber = pageIndex;
	$model.LastPageVisited = lastVisitedPage;
	document.title = pageTitle;

	//  Get the user Agent
	$model.UserAgent = navigator.userAgent;
	$model.referrer = document.referrer;
	$model.RegistrationSegmentId = null;
</script>

<PageSection>
	<div class="row justify-content-center">
		<div class="col-md-8 col-sm-12">
			<h1 class="text-center">Register for the {projectSettings.classActionName}</h1>
		</div>
	</div>
	<div class="row justify-content-md-center">
		<div class="col-md-8 col-sm-12">
			<h2 class="text-center"></h2>
			<h3 class="text-center"></h3>
			<p></p>

			<p></p>
			<p>
				If you acquired a Mortgage Protection Plan or My Protection Plan policy from Aussie Home Loans on or
				after 28 February 2018, you may be eligible for compensation, and are encouraged to register for this
				class action.
			</p>
		</div>
	</div>

	<br />
	<div class="row justify-content-md-center">
		<div class="col-md-8 col-sm-12 text-center">
			<NavigationButtons
				showPrevious="false"
				{nextPage}
				nextPageLabel="REGISTER FOR THE CLASS ACTION"
				verifyCaptcha="true"
				tealiumTag={false}
				pageName={title}
				onNext={registerFormStart}
			></NavigationButtons>
		</div>
	</div>
	<br />

	<div class="row justify-content-md-center" style="margin-top: 12px;">
		<div class="col-md-8 col-sm-12">
			<p>
				If you require support completing this form, please contact Shine Lawyers on
				<ClassActionPhoneNumber></ClassActionPhoneNumber> or via email to
				<ClassActionEmailAddress></ClassActionEmailAddress>.
			</p>
		</div>
	</div>
</PageSection>

<style>
	h1 {
		margin-bottom: 20px;
	}

	h2 {
		font-size: 1.1em;
		margin-bottom: 16px;
	}

	h2 {
		font-weight: 700;
	}

	.bold {
		font-weight: 700;
	}
</style>
